import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	goals: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.goals.goals',
		defaultMessage: 'Goals',
		description: 'Label for Goals app shortcut button',
	},
});
